import React from "react";

const EditCouncil = () => {
  return <div>EditCouncil</div>;
};

export default EditCouncil;
